const numberFormatter = new Intl.NumberFormat("en");

export function formatNumber(number: number | bigint) {
  return numberFormatter.format(number);
}

const currencyFormatter = new Intl.NumberFormat("en", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function formatCurrency(amount: number | bigint) {
  return currencyFormatter.format(amount);
}

const signaledCurrencyFormatter = new Intl.NumberFormat("en", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
  signDisplay: "exceptZero",
});

/**
 * Currency with its sign always shown, for amounts whose direction is the
 * point — support and opposition, money in and out. Zero shows no sign.
 *
 * @example formatSignaledCurrency(20000)  // "+$20,000"
 * @example formatSignaledCurrency(-20000) // "-$20,000"
 * @example formatSignaledCurrency(0)      // "$0"
 */
export function formatSignaledCurrency(amount: number | bigint) {
  return signaledCurrencyFormatter.format(amount);
}

const compactCurrencyFormatter = new Intl.NumberFormat("en", {
  style: "currency",
  currency: "USD",
  roundingPriority: "lessPrecision",
  maximumSignificantDigits: 3,
  maximumFractionDigits: 1,
  minimumFractionDigits: 0,
  notation: "compact",
} as Intl.NumberFormatOptions);

export function formatCompactCurrency(amount: number | bigint) {
  return compactCurrencyFormatter.format(amount);
}

const percentFormatter = new Intl.NumberFormat("en", {
  style: "percent",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export function formatPercentage(value: number) {
  return percentFormatter.format(value);
}

const roiFormatter = new Intl.NumberFormat("en", {
  maximumFractionDigits: 2,
});

export function formatRoi(value: number) {
  return `${roiFormatter.format(value)}x`;
}
